import { Component } from "react";
import { signUp } from '../../utilities/users-service';
// import { Link, useNavigate } from "react-router-dom";
import {removeStat} from '../../utilities/listings-service'
export default class SignUpForm extends Component {
  state = {
    name: "",
    email: "",
    password: "",
    confirm: "",
    error: ""
  }

  // navigate=useNavigate()
  removeVisitor = async ()=>{
    removeStat()
  }

  handleChange = (evt) => {
    this.setState({
      [evt.target.name]: evt.target.value,
      error: ""
    })
  }

  handleSubmit = async (evt) => {
     // Prevent form from being submitted to the server
    evt.preventDefault()
    try {
      // We don't want to send the 'error' or 'confirm' property,
      //  so let's make a copy of the state object, then delete them
      const formData = {...this.state}
      delete formData.error;
      delete formData.confirm;
      // The promise returned by the signUp service method
      // will resolve to the user object included in the
      // payload of the JSON Web Token (JWT)
      const user = await signUp(formData)
      this.props.setUser(user)
      this.removeVisitor()
    } catch {
      this.setState({ error: "Sign Up Failed - Try Again"})
    }
  }

  render() {

    
    const disable = this.state.password !== this.state.confirm;
    return (
      // this.props.user===null?
      <div className='auth-page'>
        <div className="auth-form">
          <form autoComplete="off" onSubmit={this.handleSubmit}>
            <label>Name</label>
            <input type="text" name="name" value={this.state.name} onChange={this.handleChange} required/>
            <label>Email</label>
            <input type="email" name="email" value={this.state.email} onChange={this.handleChange} required/>
            <label>Password</label>
            <input type="password" name="password" value={this.state.password} onChange={this.handleChange} required/>
            <label>Confirm</label>
            <input type="password" name="confirm" value={this.state.confirm} onChange={this.handleChange} required/>
             <button type="submit" disabled={disable}>SIGN UP</button>
          </form>
        </div>  
        <p className="error-message">&#160;{this.state.error}</p>
      </div>
      //   :
      // <div><h1>Succes</h1><Link to = "/irunthis"><h2>Listings</h2></Link></div>
    )
  }
}